module.exports = __webpack_public_path__ + "img/cvshots3.017ff83b.jpg";